import React from "react";
import "../css/returns.scss";
function Returns() {
  return (
    <main
      id="MainContent"
      className="main-content content-for-layout focus-none"
      role="main"
      tabIndex={-1}
    >
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Refund policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p className="">
              Any unused items in their original condition and packaging can be
              returned within{" "}
              <span style={{ textDecoration: "underline" }}>
                <strong>60 days of delivery</strong>
              </span>
              .
            </p>

            <ul>
              <li>
                <span style={{ textDecoration: "underline" }}>
                  <strong>
                    If you return your entire order within 14 days of delivery
                  </strong>
                </span>
                , we’ll refund the item(s) and{" "}
                <span style={{ textDecoration: "underline" }}>
                  <strong>your original standard delivery charge</strong>
                </span>{" "}
                in full.
              </li>
              <li>
                <span style={{ textDecoration: "underline" }}>
                  <strong>If only part of your order is returned</strong>
                </span>
                , the delivery charge will not be refunded.
              </li>
              <li>
                <span style={{ textDecoration: "underline" }}>
                  <strong>
                    If you return your order between days 15 and 60
                  </strong>
                </span>
                , a{" "}
                <span style={{ textDecoration: "underline" }}>
                  <strong>£5 restocking fee per order</strong>
                </span>{" "}
                will be automatically deducted from your refund.
              </li>
            </ul>
            <p className="">
              We’ll issue a refund to your original payment method within{" "}
              <span style={{ textDecoration: "underline" }}>
                <strong>5–10 business days</strong>
              </span>{" "}
              of receiving the returned items.
            </p>
            <p className="">
              <span style={{ textDecoration: "underline" }}>
                <em>
                  <strong>
                    Items that are returned damaged or without original
                    packaging will not be refunded.
                  </strong>
                </em>
              </span>
            </p>
            <p className="">
              If you receive any damaged or defective items, please let us know
              within{" "}
              <span style={{ textDecoration: "underline" }}>
                <strong>7 days</strong>
              </span>{" "}
              of delivery and we’ll make things right.
            </p>
            <p className="">&nbsp;</p>
            <h2>Non-returnable items</h2>
            <ul>
              <li>
                <span style={{ textDecoration: "underline" }}>
                  <strong>Items that have been modified in any way</strong>
                </span>
                , including being painted,{" "}
                <span style={{ textDecoration: "underline" }}>
                  <strong>are not returnable</strong>
                </span>
                .
              </li>
              <li>
                Items returned after{" "}
                <span style={{ textDecoration: "underline" }}>
                  <strong>60 days</strong>
                </span>{" "}
                that are in{" "}
                <span style={{ textDecoration: "underline" }}>
                  <strong>sellable condition</strong>
                </span>{" "}
                will be refunded as a{" "}
                <span style={{ textDecoration: "underline" }}>
                  <strong>Pedarcircle gift card</strong>
                </span>
                .
              </li>
              <li>
                Items returned after 60 days that are{" "}
                <span style={{ textDecoration: "underline" }}>
                  <strong>unsellable</strong>
                </span>{" "}
                or without original packaging will not be refunded, and we may
                not be able to return these items to you.
              </li>
            </ul>
            <p className="">
              If you send items that were{" "}
              <span style={{ textDecoration: "underline" }}>
                <strong>not purchased from Pedarcircle</strong>
              </span>
              , we cannot guarantee we’ll be able to return them to you or
              reimburse you for their value.
            </p>
            <p className="">&nbsp;</p>
            <p className="">
              If you have any questions, feel free to contact us at&nbsp;{" "}
              <strong>
                <a
                  href="mailto:draft@pedarcircle.club"
                  className="cursor-pointer"
                >
                  draft@pedarcircle.club
                </a>
              </strong>{" "}
              — we’re here to help.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Returns;
